import { useMemo } from 'react';
import { RichtextDocId, stringifyDocId } from '../../../model/RichtextDocId';
import { InlineTextFilter } from '../../../services/InlineTextOperations';
import { DEFAULT_INLINE_TEXT_FILTER } from './Constants';

/**
 * Returns a referentially stable RichtextDocId derived from an InlineTextFilter.
 * Without this, every render produces a new object that triggers effect cleanups spuriously.
 */

export function useStableDocId(filter: InlineTextFilter | undefined): RichtextDocId | undefined {
  const filterOrDefault = filter ?? DEFAULT_INLINE_TEXT_FILTER;
  const docIdOrDefault = filterOrDefault.type === 'none' ? undefined : filterOrDefault;
  const key = docIdOrDefault ? stringifyDocId(docIdOrDefault) : undefined;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => docIdOrDefault, [key]);
}
